module.exports = __webpack_public_path__ + "img/cover.fa626a96.jpg";